module.exports = __webpack_public_path__ + "static/media/placeholder-300x300.597b10d8.png";